import React, { useState } from 'react';
import { useAuth } from '@context';
import ProfilePic from '@images/profilePic.png';
import { ArrowForwardProfile, ArrowBackwardProfile, ProflieIcon, TimeCreditsXPIcon, InventoryProfileModelIcon } from '@util/svgicon';
import LifePoints from './LifePoints';
import History from './History';
import Profile from './Profile';
import FBPTokenIcon from '@images/dashboard/3DFBTToken.png';
import Inventory from './Inventory';

const ProfileDashboardMenu = ({ setSelectedOption, closeProfileModelHandler }) => {
    const { userDetails } = useAuth();
    const Bucket_url = process.env.NEXT_PUBLIC_DELIEVERY_CONTENT_URL
    const ProfilePicture = userDetails?.avatar_url ? `${Bucket_url}${userDetails?.avatar_url}` : ProfilePic;
    const [activeTab, setActiveTab] = useState(1)

    const handleTabClick = (tabNumber) => {
        setActiveTab(tabNumber)
    }

    const lbHandler = () => {
        if (activeTab < 3) {
            setActiveTab(activeTab + 1)
        }
    }

    const rbHandler = () => {
        if (activeTab > 1) {
            setActiveTab(activeTab - 1)
        }
    }

    return (
        <div className='flex flex-col items-center gap-[12px] w-[90%] h-[calc(100vh-68px)]'>
            <div className='flex px-[8px] py-0 items-center gap-[16px]'>
                <img
                    src={ProfilePicture}
                    alt="UserProfile"
                    style={{ borderRadius: '50%', width: '32px', height: '32px' }}
                />
                <p className="text-[#FAFAFA] text-center text-[32px] not-italic font-semibold leading-[32px] tracking-[-1.92px]">{userDetails?.username}</p>
            </div>
            <div className='flex flex-col items-start gap-[4px] w-full'>
                <div className='flex items-start gap-[4px] w-full'>
                    <button className="flex p-[8px] w-[6%] justify-center items-center gap-[8px] rounded-[8px] bg-[rgba(115,_115,_115,_0.25)]" onClick={rbHandler}>
                        <ArrowForwardProfile />
                    </button>
                    <div className="flex items-start gap-[8px] w-[88%] rounded-[8px] bg-[rgba(250,_250,_250,_0.25)]">
                        <button className='flex w-[33.33%] p-[8px] justify-center items-center gap-[8px] rounded-[8px]' onClick={() => handleTabClick(1)} style={activeTab === 1 ? { backgroundColor: '#737373' } : { color: '#000000' }}>
                            <ProflieIcon />
                            <p className="text-[#FAFAFA] text-center text-[16px] not-italic font-medium leading-[normal] tracking-[-0.32px]">Profile</p>
                        </button>
                        <button className='flex w-[33.33%] p-[8px] justify-center items-center gap-[8px] rounded-[8px]' onClick={() => handleTabClick(2)} style={activeTab === 2 ? { backgroundColor: '#737373' } : { color: '#000000' }}>
                            <TimeCreditsXPIcon />
                            <p className="text-[#FAFAFA] text-center text-[16px] not-italic font-medium leading-[normal] tracking-[-0.32px]">History</p>
                        </button>
                        <button className='flex w-[33.33%] p-[8px] justify-center items-center gap-[8px] rounded-[8px]' onClick={() => handleTabClick(3)} style={activeTab === 3 ? { backgroundColor: '#737373' } : { color: '#000000' }}>
                            <InventoryProfileModelIcon />
                            <p className="text-[#FAFAFA] text-center text-[16px] not-italic font-medium leading-[normal] tracking-[-0.32px]">Inventory</p>
                        </button>
                        {/* <button className='flex w-[33.33%] p-[8px] justify-center items-center gap-[8px] rounded-[8px]' onClick={() => handleTabClick(3)} style={activeTab === 3 ? { backgroundColor: '#737373' } : { color: '#000000' }}>
                            <img src={FBPTokenIcon} alt="FBPTokenIcon" style={{ width: '24px', height: '24px' }} />
                            <p className="text-[#FAFAFA] text-center text-[16px] not-italic font-medium leading-[normal] tracking-[-0.32px]">FrodoBot Points</p>
                        </button> */}
                    </div>
                    <button className="flex p-[8px] w-[6%] justify-center items-center gap-[8px] rounded-[8px] bg-[rgba(115,_115,_115,_0.25)]" onClick={lbHandler}>
                        <ArrowBackwardProfile />
                    </button>
                </div>
            </div>
            <div className='flex items-start gap-[4px] w-full h-[88%]'>
                {activeTab === 1 && <Profile />}
                {activeTab === 2 && <History />}
                {activeTab === 3 && <Inventory />}
                {activeTab === 4 &&
                    <LifePoints
                        setSelectedOption={setSelectedOption}
                        closeProfileModelHandler={closeProfileModelHandler}
                    />}
            </div>
        </div>
    )
}

export default ProfileDashboardMenu